var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestricted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 76,
    viewBox: "0 0 60 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0708 13.8995C59.0934 62.1508 64.3058 51.1958 29.434 75.4488C20.3354 69.1248 13.9735 65.1945 9.52876 61.9804L59.0708 13.8995Z",
    fill: "#FF5910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7495 0.000538925L55.7944 7.68237L6.282 55.7329C-1.9882 48.3796 0.286463 42.152 0.286463 10.3069L15.1123 0L44.7495 0.000538925Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestricted);
export default __webpack_public_path__ + "static/media/restricted.4e2ff99c6d50a65b56fd6a018dda0d66.svg";
export { ForwardRef as ReactComponent };